export default () =>
  process.env.REACT_APP_API_URL === 'https://api.tymber.io' ||
  process.env.REACT_APP_API_URL === 'https://app.tymber.io';
